/**
 * DEV-1080. Переводы формы проекта, модалки застройщика и WYSIWYG-редактора.
 *
 * Отдельным модулем, как dev1082: правки формы не конфликтуют с общим ru.ts,
 * который правят все подряд.
 */

const ruForm = {
  titleNew: 'Новый проект',
  titleEdit: 'Редактирование проекта',
  draft: 'Черновик',
  notSet: 'Не задано',
  notChecked: 'Не проверено',
  sections: {
    main: 'Основное',
    location: 'Локация',
    texts: 'Переводы',
    attributes: 'Характеристики',
    images: 'Картинки',
    publication: 'Публикация',
    service: 'Служебная информация',
  },
  name: 'Название',
  nameRequired: 'Укажите название проекта',
  nameLocale: 'Название ({locale})',
  nameNotTranslated: 'Название проекта общее для всех языков — правится в блоке «Основное»',
  amenitiesHint: 'Выбранные подсвечены — они уходят в карточку проекта на сайте',
  findOnMap: 'Найти на карте',
  addressNotFound: 'Не нашли такой адрес — поставьте точку на карте вручную',
  handoverHint: 'Квартал и год: в карточку уходит первый день квартала',
  handoverClear: 'Сбросить',
  handoverPrevYear: 'Предыдущий год',
  handoverNextYear: 'Следующий год',
  quarterMonths: {
    1: 'янв — мар',
    2: 'апр — июн',
    3: 'июл — сен',
    4: 'окт — дек',
  },
  developer: 'Застройщик',
  developerRequired: 'Выберите застройщика',
  newDeveloper: 'Новый застройщик',
  editDeveloper: 'Изменить застройщика',
  projectType: 'Тип проекта',
  projectRank: 'Класс',
  handoverDate: 'Срок сдачи',
  quarter: 'Квартал',
  year: 'Год',
  handoverCondition: 'Передача',
  numberOfBlocks: 'Количество корпусов',
  city: 'Город',
  cityRequired: 'Выберите город',
  address: 'Адрес',
  addressHint: 'Улица, район, город — минимум {min} символов',
  addressTooShort: 'Адрес короче {min} символов',
  seoTitle: 'SEO Title ({locale})',
  seoDescription: 'SEO Description ({locale})',
  description: 'Описание ({locale})',
  objectTypes: 'Типы объектов',
  objectTypesHint: 'формируется из объектов, не редактируется',
  amenities: 'Удобства',
  highlights: 'Преимущества проекта',
  documentsChecking: 'Проверка документов',
  features: 'Особенности',
  promos: 'Промо-акции',
  addPromo: 'Добавить промо',
  removePromo: 'Удалить промо',
  visibility: 'Опубликован на сайте',
  visibilityHint: 'Выключено — проект сохранён как черновик и виден только в CRM.',
  featured: 'В подборке на главной (featured)',
  availableForAgents: 'Доступен агентам',
  serviceBadge: 'Не публикуется на сайте',
  foreignerEligible: 'Доступен иностранцам',
  foreignerYes: 'Да — подтверждено',
  foreignerNo: 'Нет',
  commissionPercent: 'Комиссия, %',
  commissionNote: 'Примечание',
  commissionRange: 'Комиссия — число от 0 до 100',
  salesStage: 'Стадия продаж',
  website: 'Сайт застройщика',
  created: 'Проект создан',
  updated: 'Проект сохранён',
  saveError: 'Не удалось сохранить проект',
  loadError: 'Не удалось загрузить данные проекта',
  validationError: 'Заполните обязательные поля',
  projectTypeValues: {
    PROJECT_TYPE_RESIDENTIAL_COMPLEX: 'Жилой комплекс',
    PROJECT_TYPE_GATED_COMMUNITY: 'Закрытый посёлок',
    PROJECT_TYPE_HOLIDAY_HOMES: 'Курортная недвижимость',
    PROJECT_TYPE_COMMERCIAL_REAL_ESTATE: 'Коммерческая недвижимость',
  },
  projectRankValues: {
    PROJECT_RANK_AFFORDABLE: 'Эконом',
    PROJECT_RANK_MID_END: 'Комфорт',
    PROJECT_RANK_HIGH_END: 'Бизнес',
    PROJECT_RANK_LUXURY: 'Люкс',
  },
  salesStageValues: {
    SALES_STAGE_PRESALE: 'Пресейл',
    SALES_STAGE_BOOKING: 'Бронирование',
    SALES_STAGE_OPEN_SALES: 'Открытые продажи',
    SALES_STAGE_SOLD_OUT: 'Распродан',
    SALES_STAGE_SUSPENDED: 'Продажи приостановлены',
  },
  amenityValues: {
    AMENITY_SWIMMING_POOL: 'Бассейн',
    AMENITY_KIDS_POOL: 'Детский бассейн',
    AMENITY_GYM: 'Спортзал',
    AMENITY_SPA: 'СПА',
    AMENITY_YOGA: 'Йога',
    AMENITY_TENNIS_COURT: 'Теннисный корт',
    AMENITY_JOGGING_PATH: 'Беговые дорожки',
    AMENITY_KIDS_PLAYGROUND: 'Детская зона',
    AMENITY_GREEN_AREA: 'Озеленение',
    AMENITY_BBQ: 'Зона барбекю',
    AMENITY_COMMUNITY_ROOM: 'Общественная зона',
    AMENITY_RESTAURANT: 'Ресторан',
    AMENITY_CAFE: 'Кафе',
    AMENITY_BAR: 'Бар',
    AMENITY_CONVENIENCE_STORE: 'Магазин',
    AMENITY_SHOPPING_MALL: 'Торговый центр',
    AMENITY_KINDERGARTEN: 'Детский сад',
    AMENITY_SCHOOL: 'Школа',
    AMENITY_COLLEGE: 'Колледж',
    AMENITY_PARKING: 'Парковка',
  },
  highlightValues: {
    HIGHLIGHT_REPUTABLE_DEVELOPER: 'Надёжный застройщик',
    HIGHLIGHT_INSTALLMENT_PLAN: 'Программа рассрочки',
    HIGHLIGHT_FULL_LEGAL_GROUND: 'Полная юр. чистота',
    HIGHLIGHT_FREE_HIGH_APPRECIATION_POTENTIAL: 'Потенциал роста',
  },
  documentValues: {
    DEVELOPERS_DOCUMENTS_CHECKING_CONSTRUCTION_PERMIT: 'Разрешение на строительство',
    DEVELOPERS_DOCUMENTS_CHECKING_LAND_USE_RIGHT_CERTIFICATE: 'Сертификат прав на землю',
    DEVELOPERS_DOCUMENTS_CHECKING_BANK_LETTER_OF_GUARANTEE: 'Банковская гарантия',
    DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT: 'Разрешение на продажу',
    DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT_FOR_FOREIGNERS: 'Разрешение на продажу иностранцам',
  },
  featureValues: {
    RESIDENTIAL_COMPLEX_FEATURE_DOCS_CHECKED: 'Документы проверены',
    RESIDENTIAL_COMPLEX_FEATURE_VIDEO_AVAILABLE: 'Есть видео',
    RESIDENTIAL_COMPLEX_FEATURE_HANDOVERED: 'Сдан',
    RESIDENTIAL_COMPLEX_FEATURE_PINK_BOOK_AVAILABLE: 'Розовая книга',
    RESIDENTIAL_COMPLEX_FEATURE_AVAILABLE_FOR_FOREIGNERS: 'Доступен иностранцам',
    RESIDENTIAL_COMPLEX_FEATURE_FAVORITES: 'Избранное',
  },
  location: {
    pickHint: 'Кликните по карте, чтобы поставить точку проекта',
    clear: 'Очистить',
  },
  images: {
    urlPlaceholder: 'https://… вставьте ссылку на изображение',
    addToList: 'В список',
    pending: 'Готовы к загрузке: {count}',
    uploadAll: 'Загрузить все',
    upload: 'Загрузить',
    remove: 'Удалить',
    onMain: 'Главная',
    preview: 'Превью',
    uploaded: 'Загружено картинок: {count}',
    urlFailed: 'Не удалось скачать ссылок: {count}',
    uploadError: 'Не удалось загрузить изображение',
    categories: 'Категории — как на сайте и в карточке',
    empty: 'пусто',
    exactlyOne: 'ровно одна',
    newType: 'новая',
    dropHere: 'Перетащите сюда',
    types: {
      IMAGE_TYPE_MAIN_IMAGE: 'Шапка',
      IMAGE_TYPE_CONSTRUCTION_STAGE: 'Ход строительства',
      IMAGE_TYPE_FINISHING_STAGE: 'Отделка',
      IMAGE_TYPE_COMMON: 'Общие',
      IMAGE_TYPE_MAIN_PLAN: 'Генплан',
      IMAGE_TYPE_EXTERIOR: 'Экстерьер',
      IMAGE_TYPE_INTERIOR: 'Интерьер',
      IMAGE_TYPE_FLOOR_PLAN: 'Поэтажные планы',
      IMAGE_TYPE_LAYOUT: 'Планировки',
    },
    hints: {
      IMAGE_TYPE_MAIN_IMAGE: '→ hero-карусель страницы проекта на сайте',
      IMAGE_TYPE_CONSTRUCTION_STAGE: '→ секция «Ход строительства» на сайте',
      IMAGE_TYPE_FINISHING_STAGE: '→ секция «Варианты отделки» на сайте',
      IMAGE_TYPE_COMMON: '→ галерея «О проекте» на сайте',
      IMAGE_TYPE_MAIN_PLAN: '→ секция «Мастер-план» на сайте · ровно 1 файл, без флагов',
      IMAGE_TYPE_EXTERIOR: '→ галерея сайта · папка EXTERIOR из Drive',
      IMAGE_TYPE_INTERIOR: '→ галерея сайта · папка INTERIOR из Drive',
      IMAGE_TYPE_FLOOR_PLAN: '→ галерея сайта · поэтажные планы корпусов',
      IMAGE_TYPE_LAYOUT: '→ галерея сайта · планировки квартир',
    },
  },
}

const ruDeveloper = {
  titleNew: 'Новый застройщик',
  titleEdit: 'Редактирование застройщика',
  name: 'Название',
  nameRequired: 'Укажите название застройщика',
  logo: 'Логотип',
  pickFile: 'Выбрать файл',
  addByUrl: 'Добавить по ссылке',
  logoHint: 'PNG/JPG · 1 файл',
  logoError: 'Не удалось загрузить логотип',
  urlPrompt: 'Ссылка на логотип',
  feature: 'Категория',
  features: {
    DEVELOPER_FEATURE_FOUNDED: 'Основан',
    DEVELOPER_FEATURE_PROJECT_UNDER_CONSTRUCTION: 'Строящиеся проекты',
    DEVELOPER_FEATURE_PROJECT_COMPLETED_PROJECTS: 'Завершённые проекты',
  },
  visibility: 'Виден на сайте',
  description: 'Описание',
  ruRequired: 'RU обязателен',
  ruRequiredError: 'Заполните описание на русском — оно попадает на сайт',
  saved: 'Застройщик сохранён',
  saveError: 'Не удалось сохранить застройщика',
  loadError: 'Не удалось загрузить застройщика',
}

const ruEditor = {
  bold: 'Полужирный',
  italic: 'Курсив',
  underline: 'Подчёркнутый',
  strike: 'Зачёркнутый',
  color: 'Цвет текста',
  subscript: 'Нижний индекс',
  superscript: 'Верхний индекс',
  bulletList: 'Маркированный список',
  orderedList: 'Нумерованный список',
  taskList: 'Чек-лист',
  blockquote: 'Цитата',
  code: 'Код',
  link: 'Ссылка',
  linkPrompt: 'Адрес ссылки',
  alignLeft: 'По левому краю',
  alignCenter: 'По центру',
  alignRight: 'По правому краю',
  alignJustify: 'По ширине',
  undo: 'Отменить',
  redo: 'Повторить',
  fullscreen: 'На весь экран',
  exitFullscreen: 'Свернуть',
}

const enForm = {
  ...ruForm,
  titleNew: 'New project',
  titleEdit: 'Edit project',
  draft: 'Draft',
  notSet: 'Not set',
  notChecked: 'Not checked',
  sections: {
    main: 'General',
    location: 'Location',
    texts: 'Translations',
    attributes: 'Attributes',
    images: 'Images',
    publication: 'Publication',
    service: 'Internal information',
  },
  name: 'Name',
  nameRequired: 'Enter the project name',
  nameLocale: 'Name ({locale})',
  nameNotTranslated: 'The project name is shared across languages — edit it in «Main»',
  amenitiesHint: 'Selected ones are highlighted — they go to the project page on the site',
  findOnMap: 'Find on the map',
  addressNotFound: 'No such address found — drop the pin on the map manually',
  handoverHint: 'Quarter and year: the card stores the first day of the quarter',
  handoverClear: 'Reset',
  handoverPrevYear: 'Previous year',
  handoverNextYear: 'Next year',
  quarterMonths: {
    1: 'Jan — Mar',
    2: 'Apr — Jun',
    3: 'Jul — Sep',
    4: 'Oct — Dec',
  },
  developer: 'Developer',
  developerRequired: 'Select a developer',
  newDeveloper: 'New developer',
  editDeveloper: 'Edit developer',
  projectType: 'Project type',
  projectRank: 'Class',
  handoverDate: 'Handover date',
  quarter: 'Quarter',
  year: 'Year',
  handoverCondition: 'Handover condition',
  numberOfBlocks: 'Number of blocks',
  city: 'City',
  cityRequired: 'Select a city',
  address: 'Address',
  addressHint: 'Street, district, city — at least {min} characters',
  addressTooShort: 'Address is shorter than {min} characters',
  description: 'Description ({locale})',
  objectTypes: 'Object types',
  objectTypesHint: 'derived from objects, not editable',
  amenities: 'Amenities',
  highlights: 'Project highlights',
  documentsChecking: 'Documents check',
  features: 'Features',
  promos: 'Promotions',
  addPromo: 'Add promotion',
  removePromo: 'Remove promotion',
  visibility: 'Published on the website',
  visibilityHint: 'Off — the project is saved as a draft and visible in CRM only.',
  featured: 'Featured on the homepage',
  availableForAgents: 'Available to agents',
  serviceBadge: 'Not published on the website',
  foreignerEligible: 'Available to foreigners',
  foreignerYes: 'Yes — confirmed',
  foreignerNo: 'No',
  commissionPercent: 'Commission, %',
  commissionNote: 'Note',
  commissionRange: 'Commission must be between 0 and 100',
  salesStage: 'Sales stage',
  website: 'Developer website',
  created: 'Project created',
  updated: 'Project saved',
  saveError: 'Failed to save the project',
  loadError: 'Failed to load project data',
  validationError: 'Fill in the required fields',
  projectTypeValues: {
    PROJECT_TYPE_RESIDENTIAL_COMPLEX: 'Residential complex',
    PROJECT_TYPE_GATED_COMMUNITY: 'Gated community',
    PROJECT_TYPE_HOLIDAY_HOMES: 'Holiday homes',
    PROJECT_TYPE_COMMERCIAL_REAL_ESTATE: 'Commercial real estate',
  },
  projectRankValues: {
    PROJECT_RANK_AFFORDABLE: 'Affordable',
    PROJECT_RANK_MID_END: 'Mid-end',
    PROJECT_RANK_HIGH_END: 'High-end',
    PROJECT_RANK_LUXURY: 'Luxury',
  },
  salesStageValues: {
    SALES_STAGE_PRESALE: 'Presale',
    SALES_STAGE_BOOKING: 'Booking',
    SALES_STAGE_OPEN_SALES: 'Open sales',
    SALES_STAGE_SOLD_OUT: 'Sold out',
    SALES_STAGE_SUSPENDED: 'Suspended',
  },
  amenityValues: {
    AMENITY_SWIMMING_POOL: 'Swimming pool',
    AMENITY_KIDS_POOL: 'Kids pool',
    AMENITY_GYM: 'Gym',
    AMENITY_SPA: 'Spa',
    AMENITY_YOGA: 'Yoga',
    AMENITY_TENNIS_COURT: 'Tennis court',
    AMENITY_JOGGING_PATH: 'Jogging path',
    AMENITY_KIDS_PLAYGROUND: 'Kids playground',
    AMENITY_GREEN_AREA: 'Green area',
    AMENITY_BBQ: 'BBQ area',
    AMENITY_COMMUNITY_ROOM: 'Community room',
    AMENITY_RESTAURANT: 'Restaurant',
    AMENITY_CAFE: 'Cafe',
    AMENITY_BAR: 'Bar',
    AMENITY_CONVENIENCE_STORE: 'Convenience store',
    AMENITY_SHOPPING_MALL: 'Shopping mall',
    AMENITY_KINDERGARTEN: 'Kindergarten',
    AMENITY_SCHOOL: 'School',
    AMENITY_COLLEGE: 'College',
    AMENITY_PARKING: 'Parking',
  },
  highlightValues: {
    HIGHLIGHT_REPUTABLE_DEVELOPER: 'Reputable developer',
    HIGHLIGHT_INSTALLMENT_PLAN: 'Installment plan',
    HIGHLIGHT_FULL_LEGAL_GROUND: 'Full legal ground',
    HIGHLIGHT_FREE_HIGH_APPRECIATION_POTENTIAL: 'High appreciation potential',
  },
  documentValues: {
    DEVELOPERS_DOCUMENTS_CHECKING_CONSTRUCTION_PERMIT: 'Construction permit',
    DEVELOPERS_DOCUMENTS_CHECKING_LAND_USE_RIGHT_CERTIFICATE: 'Land use right certificate',
    DEVELOPERS_DOCUMENTS_CHECKING_BANK_LETTER_OF_GUARANTEE: 'Bank letter of guarantee',
    DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT: 'Sale permit',
    DEVELOPERS_DOCUMENTS_CHECKING_SALE_PERMIT_FOR_FOREIGNERS: 'Sale permit for foreigners',
  },
  featureValues: {
    RESIDENTIAL_COMPLEX_FEATURE_DOCS_CHECKED: 'Documents checked',
    RESIDENTIAL_COMPLEX_FEATURE_VIDEO_AVAILABLE: 'Video available',
    RESIDENTIAL_COMPLEX_FEATURE_HANDOVERED: 'Handed over',
    RESIDENTIAL_COMPLEX_FEATURE_PINK_BOOK_AVAILABLE: 'Pink book available',
    RESIDENTIAL_COMPLEX_FEATURE_AVAILABLE_FOR_FOREIGNERS: 'Available to foreigners',
    RESIDENTIAL_COMPLEX_FEATURE_FAVORITES: 'Favorites',
  },
  location: {
    pickHint: 'Click on the map to place the project marker',
    clear: 'Clear',
  },
  images: {
    urlPlaceholder: 'https://… paste an image link',
    addToList: 'Add to list',
    pending: 'Ready to upload: {count}',
    uploadAll: 'Upload all',
    upload: 'Upload',
    remove: 'Remove',
    onMain: 'Homepage',
    preview: 'Preview',
    uploaded: 'Images uploaded: {count}',
    urlFailed: 'Links failed: {count}',
    uploadError: 'Failed to upload the image',
    categories: 'Categories — as on the site and in the card',
    empty: 'empty',
    exactlyOne: 'exactly one',
    newType: 'new',
    dropHere: 'Drop here',
    types: {
      IMAGE_TYPE_MAIN_IMAGE: 'Header',
      IMAGE_TYPE_CONSTRUCTION_STAGE: 'Construction progress',
      IMAGE_TYPE_FINISHING_STAGE: 'Finishing',
      IMAGE_TYPE_COMMON: 'Common',
      IMAGE_TYPE_MAIN_PLAN: 'Master plan',
      IMAGE_TYPE_EXTERIOR: 'Exterior',
      IMAGE_TYPE_INTERIOR: 'Interior',
      IMAGE_TYPE_FLOOR_PLAN: 'Floor plans',
      IMAGE_TYPE_LAYOUT: 'Unit layouts',
    },
    hints: {
      IMAGE_TYPE_MAIN_IMAGE: '→ hero carousel of the project page',
      IMAGE_TYPE_CONSTRUCTION_STAGE: '→ «Construction progress» section',
      IMAGE_TYPE_FINISHING_STAGE: '→ «Finishing options» section',
      IMAGE_TYPE_COMMON: '→ «About the project» gallery',
      IMAGE_TYPE_MAIN_PLAN: '→ «Master plan» section · exactly 1 file, no flags',
      IMAGE_TYPE_EXTERIOR: '→ site gallery · EXTERIOR folder from Drive',
      IMAGE_TYPE_INTERIOR: '→ site gallery · INTERIOR folder from Drive',
      IMAGE_TYPE_FLOOR_PLAN: '→ site gallery · building floor plans',
      IMAGE_TYPE_LAYOUT: '→ site gallery · unit layouts',
    },
  },
}

const enDeveloper = {
  titleNew: 'New developer',
  titleEdit: 'Edit developer',
  name: 'Name',
  nameRequired: 'Enter the developer name',
  logo: 'Logo',
  pickFile: 'Choose file',
  addByUrl: 'Add by link',
  logoHint: 'PNG/JPG · 1 file',
  logoError: 'Failed to upload the logo',
  urlPrompt: 'Logo link',
  feature: 'Category',
  features: {
    DEVELOPER_FEATURE_FOUNDED: 'Founded',
    DEVELOPER_FEATURE_PROJECT_UNDER_CONSTRUCTION: 'Projects under construction',
    DEVELOPER_FEATURE_PROJECT_COMPLETED_PROJECTS: 'Completed projects',
  },
  visibility: 'Visible on the website',
  description: 'Description',
  ruRequired: 'RU required',
  ruRequiredError: 'Fill in the Russian description — it goes to the website',
  saved: 'Developer saved',
  saveError: 'Failed to save the developer',
  loadError: 'Failed to load the developer',
}

const enEditor = {
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  strike: 'Strikethrough',
  color: 'Text color',
  subscript: 'Subscript',
  superscript: 'Superscript',
  bulletList: 'Bullet list',
  orderedList: 'Ordered list',
  taskList: 'Checklist',
  blockquote: 'Quote',
  code: 'Code',
  link: 'Link',
  linkPrompt: 'Link URL',
  alignLeft: 'Align left',
  alignCenter: 'Align center',
  alignRight: 'Align right',
  alignJustify: 'Justify',
  undo: 'Undo',
  redo: 'Redo',
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit fullscreen',
}

const vnForm = {
  ...enForm,
  titleNew: 'Dự án mới',
  titleEdit: 'Chỉnh sửa dự án',
  draft: 'Bản nháp',
  notSet: 'Chưa đặt',
  notChecked: 'Chưa kiểm tra',
  sections: {
    main: 'Thông tin chung',
    location: 'Vị trí',
    texts: 'Bản dịch',
    attributes: 'Đặc điểm',
    images: 'Hình ảnh',
    publication: 'Xuất bản',
    service: 'Thông tin nội bộ',
  },
  name: 'Tên',
  nameRequired: 'Nhập tên dự án',
  nameLocale: 'Tên ({locale})',
  nameNotTranslated: 'Tên dự án dùng chung cho mọi ngôn ngữ — sửa ở khối «Thông tin chính»',
  amenitiesHint: 'Mục đã chọn được tô sáng — chúng hiển thị trong hồ sơ dự án trên website',
  findOnMap: 'Tìm trên bản đồ',
  addressNotFound: 'Không tìm thấy địa chỉ — hãy đặt điểm trên bản đồ thủ công',
  handoverHint: 'Quý và năm: hồ sơ lưu ngày đầu tiên của quý',
  handoverClear: 'Đặt lại',
  handoverPrevYear: 'Năm trước',
  handoverNextYear: 'Năm sau',
  quarterMonths: {
    1: 'Th1 — Th3',
    2: 'Th4 — Th6',
    3: 'Th7 — Th9',
    4: 'Th10 — Th12',
  },
  developer: 'Chủ đầu tư',
  developerRequired: 'Chọn chủ đầu tư',
  newDeveloper: 'Chủ đầu tư mới',
  editDeveloper: 'Sửa chủ đầu tư',
  projectType: 'Loại dự án',
  projectRank: 'Phân khúc',
  handoverDate: 'Thời gian bàn giao',
  quarter: 'Quý',
  year: 'Năm',
  handoverCondition: 'Tình trạng bàn giao',
  numberOfBlocks: 'Số tòa',
  city: 'Thành phố',
  cityRequired: 'Chọn thành phố',
  address: 'Địa chỉ',
  addressHint: 'Đường, quận, thành phố — tối thiểu {min} ký tự',
  addressTooShort: 'Địa chỉ ngắn hơn {min} ký tự',
  description: 'Mô tả ({locale})',
  objectTypes: 'Loại sản phẩm',
  objectTypesHint: 'lấy từ danh sách sản phẩm, không sửa được',
  amenities: 'Tiện ích',
  highlights: 'Điểm nổi bật',
  documentsChecking: 'Kiểm tra pháp lý',
  features: 'Đặc điểm',
  promos: 'Khuyến mãi',
  addPromo: 'Thêm khuyến mãi',
  removePromo: 'Xóa khuyến mãi',
  visibility: 'Hiển thị trên website',
  visibilityHint: 'Tắt — dự án được lưu dưới dạng nháp và chỉ hiển thị trong CRM.',
  featured: 'Nổi bật trên trang chủ',
  availableForAgents: 'Mở cho đại lý',
  serviceBadge: 'Không hiển thị trên website',
  foreignerEligible: 'Người nước ngoài mua được',
  foreignerYes: 'Có — đã xác nhận',
  foreignerNo: 'Không',
  commissionPercent: 'Hoa hồng, %',
  commissionNote: 'Ghi chú',
  commissionRange: 'Hoa hồng phải từ 0 đến 100',
  salesStage: 'Giai đoạn bán hàng',
  website: 'Website chủ đầu tư',
  created: 'Đã tạo dự án',
  updated: 'Đã lưu dự án',
  saveError: 'Không lưu được dự án',
  loadError: 'Không tải được dữ liệu dự án',
  validationError: 'Điền các trường bắt buộc',
  location: {
    pickHint: 'Nhấp vào bản đồ để đặt vị trí dự án',
    clear: 'Xóa',
  },
}

const vnDeveloper = {
  ...enDeveloper,
  titleNew: 'Chủ đầu tư mới',
  titleEdit: 'Chỉnh sửa chủ đầu tư',
  name: 'Tên',
  nameRequired: 'Nhập tên chủ đầu tư',
  logo: 'Logo',
  pickFile: 'Chọn tệp',
  addByUrl: 'Thêm bằng liên kết',
  visibility: 'Hiển thị trên website',
  description: 'Mô tả',
  ruRequired: 'Bắt buộc RU',
  ruRequiredError: 'Điền mô tả tiếng Nga — nội dung này lên website',
  saved: 'Đã lưu chủ đầu tư',
  saveError: 'Không lưu được chủ đầu tư',
  loadError: 'Không tải được chủ đầu tư',
}

export const dev1080Messages = {
  ru: { properties: { form: ruForm, developer: ruDeveloper, editor: ruEditor } },
  en: { properties: { form: enForm, developer: enDeveloper, editor: enEditor } },
  vn: { properties: { form: vnForm, developer: vnDeveloper, editor: enEditor } },
}
